import { motion, type MotionProps } from "framer-motion";
import type { InputHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export type InputBoxProps = InputHTMLAttributes<HTMLInputElement> &
	MotionProps & { error?: boolean };

export const InputBox = ({ className, error, ...props }: InputBoxProps) => (
	<motion.input
		className={cn(
			"p-[14px] rounded-[10px] bg-bg-regular text-ct-strong placeholder:text-ct-regular text-sm font-normal",
			error && "outline-dg-strong",
			className,
		)}
		{...props}
	/>
);
